import { render, staticRenderFns } from "./PageHeader.component.vue?vue&type=template&id=083af2f1&scoped=true"
import script from "./PageHeader.component.vue?vue&type=script&lang=ts"
export * from "./PageHeader.component.vue?vue&type=script&lang=ts"
import style0 from "./PageHeader.component.vue?vue&type=style&index=0&id=083af2f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083af2f1",
  null
  
)

export default component.exports